module.exports = __webpack_public_path__ + "img/PMangonelGalley64_ua.dc68a2ad.webp";